import React, { useRef } from 'react';
import { useAtomValue } from 'jotai';
import { isDesktopAtom, isLegendControlOpenAtom, isSeparateDisplayControllerAtom, selectedFeatureAtom } from '../../atoms';
import './MapDataContainer.css';
import DataPanel from '../dataPanel/DataPanel';
import NonLngLatDataPanel from '../nonLngLatDataPanel/NonLngLatDataPanel';
import LegendPopup from '../legend/LegendPopup';
import classNames from 'classnames';
import { nonLngLatDataType } from '../../types';
import { MAIN_MAP_ID, SECOND_MAP_ID } from '../../constants/components/map';


type MapDataContainerProps = {
    mapClickEvent: maplibregl.MapMouseEvent | undefined;
    map: maplibregl.Map | null;
    setMapClickEvent: (event: maplibregl.MapMouseEvent | undefined) => void;
    nonLngLatDataArr: nonLngLatDataType[] | undefined;
    mapType?: typeof SECOND_MAP_ID | typeof MAIN_MAP_ID;
}


const MapDataContainer: React.FC<MapDataContainerProps> = ({ mapClickEvent, map, setMapClickEvent, nonLngLatDataArr, mapType }) => {
    
    const selectedFeatures = useAtomValue(selectedFeatureAtom);
    const isDesktop = useAtomValue(isDesktopAtom);
    const isLegendControlOpen = useAtomValue(isLegendControlOpenAtom);                  // 凡例表示フラグ
    const isSeparateDisplay = useAtomValue(isSeparateDisplayControllerAtom);            // 2画面表示フラグ

    const containerRef = useRef<HTMLDivElement>(null);
    const noLatLngContainerRef = useRef<HTMLDivElement>(null);

    let remainingHeight = 0;
    if (containerRef.current && noLatLngContainerRef.current) {
        const browserHeight = window.innerHeight;
        const adjustedHeight = browserHeight - 136;
        remainingHeight = isDesktop ? adjustedHeight - noLatLngContainerRef.current.clientHeight : 0;
    }

    if (!nonLngLatDataArr && !selectedFeatures && !isLegendControlOpen) { return <></>; }

    const renderLegendPopup = () => {
        if (!isLegendControlOpen) return null;

        const visibleNonLngLatDataArr = nonLngLatDataArr?.filter(panel => panel.isShow) ?? [];
        const showLegendInSecondRow = isDesktop && (visibleNonLngLatDataArr.length > 0 || !!mapClickEvent);

        if (showLegendInSecondRow) {
            return (
                <div className={classNames({'second-row': showLegendInSecondRow})}>
                    <LegendPopup remainingHeight={remainingHeight} mapType={mapType}/>
                </div>
            );
        } else {
            return <LegendPopup remainingHeight={remainingHeight} mapType={mapType}/>;
        }
    }

    return (
        <div className={classNames('map-data-container', {'is-separate-display': isSeparateDisplay})} ref={containerRef}>
            <div className={classNames('nonlnglatdata-container', {'container-low': !!mapClickEvent})} ref={noLatLngContainerRef}>
                {
                    nonLngLatDataArr?.map((panel, index) => (
                        <NonLngLatDataPanel key={index} title={panel.title} data={panel.data} isShow={panel.isShow} />
                    ))
                }
            </div>
            {
                mapClickEvent &&
                    <DataPanel 
                        remainingHeight={remainingHeight} 
                        mapClickEvent={mapClickEvent} 
                        map={map}
                        setMapClickEvent={setMapClickEvent}
                    />
            }
            { renderLegendPopup() }
        </div>
    );
};

export default MapDataContainer;
